import { render } from "./course-six.vue?vue&type=template&id=24b969b4"
import script from "./course-six.vue?vue&type=script&lang=js"
export * from "./course-six.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__